<template lang="pug">
#ads-page.page
  .ads-page-list.columns
    .column.is-one-quarter
      Ad(
        :position="defaultAd.position"
        :status="defaultAd.status"
        :title="defaultAd.title"
        :content="defaultAd.content"
        :url="defaultAd.url"
        :imageUrl="defaultAd.imageUrl"
        :startDate="defaultAd.startDate"
        :endDate="defaultAd.endDate"
      )
    .column.is-one-quarter(v-for="ad of ads")
      Ad(
        :position="ad.position"
        :status="ad.status"
        :title="ad.title"
        :content="ad.content"
        :url="ad.url"
        :imageUrl="ad.imageUrl"
        :startDate="ad.startDate"
        :endDate="ad.endDate"
        :key="ad._id"
      )
</template>

<script>
import EditInput from "@/components/EditInput";
import Checkbox from "@/components/Checkbox";
import Ad from "@/components/Ad";

const ADS_STATUS_ENUM = {
  ACTIVE: "active",
  INACTIVE: "inactive"
};

const ADS_POSITION_ENUM = {
  TOP: "top",
  MIDDLE: "middle",
  BOTTOM: "bottom",
  LEFT: "left",
  RIGHT: "right"
};

export default {
  name: "AdsPage",
  components: {
    EditInput,
    Checkbox,
    Ad
  },
  computed: {
    ads() {
      return this.$store.state.ads.list;
    }
  },
  data: () => ({
    isLoading: false,
    defaultAd: {
      position: ADS_POSITION_ENUM.TOP,
      status: ADS_STATUS_ENUM.INACTIVE,
      title: "",
      content: "",
      url: "",
      imageUrl: "",
      startDate: new Date().toISOString(),
      endDate: new Date().toISOString()
    }
  }),
  methods: {},
  mounted() {
    if (!this.ads.length) {
      return this.$store.dispatch("getAds").catch(text => {
        this.$notify({
          type: "error",
          title: "Get Ads list error",
          text
        });
      });
    }
  }
};
</script>
